import { createReducer, on } from '@ngrx/store';
import * as fromRideAction from '../actions/ride.action';

export const featureKey = 'ride';

export interface State {
  routeLines: {
    data: Array<any>,
    isLoaded: Boolean
  };
  busStops: {
    data: Array<any>,
    isLoaded: Boolean
  };
  busActivity: {
    data: Array<any>,
    busInfo: any,
    routeCoordinates: any,
    isLoaded: Boolean
  };
  rideHistory: {
    data: Array<any>,
    isLoaded: Boolean
  };
}

export const initialState: State = {
  routeLines: {
    data: [],
    isLoaded: false
  },
  busStops: {
    data: [],
    isLoaded: false
  },
  busActivity: {
    data: [],
    busInfo: null,
    routeCoordinates: [],
    isLoaded: false
  },
  rideHistory: {
    data: [],
    isLoaded: false
  },
};

export const reducer = createReducer(
  initialState,  
  on(fromRideAction.getRouteLinesSuccess, (state: State, props: any) => ({
    ...state,
    routeLines: {data: props.data, isLoaded: true}
  })),
  on(fromRideAction.getBustStopsSuccess, (state: State, props: any) => ({
    ...state,
    busStops: { data: props.data, isLoaded: true}
  })),
  on(fromRideAction.getBusActivitySuccess, (state: State, props: any) => ({
    ...state,
    busActivity: {data: props.data, busInfo: props.busInfo, routeCoordinates: props?.routeCoordinates, isLoaded: true}
  })),
  on(fromRideAction.getRideHistorySuccess, (state: State, props: any) => ({
    ...state,
    rideHistory: { data: props.data, isLoaded: true}
  })),
);
